import ServicePage from "../components/ServicePage";

export default function GestioneSitiWeb() {
  return (
    <ServicePage
      seo={{
        title: "Gestione Siti Web | Manutenzione Mensile, Sicurezza e Aggiornamenti — Lumora",
        description:
          "Gestione completa del tuo sito web: hosting, backup giornalieri, sicurezza, aggiornamenti contenuti e assistenza prioritaria. Tu pensi alla tua attività, al sito pensiamo noi.",
        path: "/gestione-siti-web",
      }}
      kicker="Gestione e manutenzione"
      h1="Gestione del sito web senza pensieri, ogni mese"
      lead="Un sito non è mai finito: va aggiornato, protetto e migliorato di continuo. Con la nostra gestione mensile hai un unico referente per tutto — hosting, dominio, sicurezza, modifiche ai contenuti e assistenza — mentre tu ti concentri sulla tua attività."
      features={[
        "Hosting, dominio e certificato di sicurezza gestiti da noi: niente scadenze da ricordare né fornitori da rincorrere.",
        "Backup giornalieri automatici: qualsiasi cosa accada, il tuo sito si ripristina in fretta.",
        "Aggiornamenti ai contenuti inclusi: testi, foto, orari, prezzi e novità, basta una richiesta dalla tua area clienti.",
        "Monitoraggio e sicurezza proattivi: teniamo il sito veloce, online e protetto.",
        "Assistenza prioritaria con risposta entro 24 ore lavorative, anche dalla chat H24 del sito.",
        "Un unico referente: niente call center, parli sempre con chi il sito lo conosce davvero.",
      ]}
      priceTitle="Gestione da €79/mese, tutto incluso"
      priceDesc="Un canone prevedibile che copre ogni aspetto tecnico del tuo sito. Puoi aggiungere il piano SEO Growth a €199/mese per crescere su Google, e disdire quando vuoi direttamente dalla tua area clienti."
      faqs={[
        {
          q: "Cosa succede se smetto di pagare la gestione?",
          a: "Il sito resta tuo: la creazione è pagata una tantum e il lavoro fatto non si perde. Senza gestione attiva si fermano hosting, aggiornamenti e assistenza.",
        },
        {
          q: "Posso chiedere modifiche ai contenuti ogni volta che voglio?",
          a: "Sì: testi, foto, orari, listini e novità sono inclusi. Apri una richiesta dalla tua area clienti e la evadiamo, in genere entro 24 ore lavorative.",
        },
        {
          q: "Gestite anche siti non creati da voi?",
          a: "Valutiamo caso per caso: se il sito esistente è tecnicamente sano possiamo prenderlo in carico, altrimenti ti proponiamo un restyling concreto con costi chiari.",
        },
      ]}
      related={[
        { path: "/creazione-siti-web-novara", label: "Creazione siti web a Novara" },
        { path: "/web-design-novara", label: "Web design a Novara" },
        { path: "/seo-novara", label: "SEO a Novara" },
      ]}
    />
  );
}
